import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type CreateProductCategoryMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CreateCoreProductCategoryInput;
}>;

export type CreateProductCategoryMutationResult = { __typename?: 'Mutation' } & {
  createCoreProductCategory: { __typename?: 'CreateCoreProductCategoryPayload' } & {
    coreProductCategory?: GraphQLTypes.Maybe<
      { __typename?: 'CoreProductCategory' } & Pick<GraphQLTypes.CoreProductCategory, 'id' | 'name'>
    >;
    errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
  };
};

export const CreateProductCategoryDocument = gql`
  mutation createProductCategory($input: CreateCoreProductCategoryInput!) {
    createCoreProductCategory(input: $input) {
      coreProductCategory {
        id
        name
      }
      errors {
        message
        path
      }
    }
  }
`;
